import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";

export const ModalBulkDebitModal = ({
  show,
  toggle,
  handleUploadFile,
  date,
  time,
  setDate, 
  setTime,
  handleFileChange,
  note,
  setNote
}) => {
  
  const navigate = useNavigate();
  const [proceed, setProceed] = useState(false)
  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Debit Mandate</Modal.Title>
        </div>
      </Modal.Header>
      {!proceed && <div>
      <Modal.Body>
        <p>Are you sure you want to debit this mandate?</p>
        <Form onSubmit={async(e) => {
          e.preventDefault()
        //   console.log("date ", date, "time ", time);
        // toggle()
          await handleUploadFile()
            // setProceed(true)
          }}>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control
            type="date"
            required
            value={date}
            onChange={(e) => setDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Time</Form.Label>
            <Form.Control
            type="time"
            required
            value={time}
            onChange={(e) => setTime(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>File</Form.Label>
            <Form.Control
            type="file"
            required
            onChange={handleFileChange}
            />
          </Form.Group>

          <Form.Group>
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                      required
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                      />
                    </Form.Group>
          <div style={{padding: "16px", display: "flex", justifyContent: "flex-end"}}>
      <Button
      type="submit"
          style={{
            // backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          
        //   disabled={isUpdating}
        >
          Proceed
        </Button>
      </div>
        </Form>
      </Modal.Body>
      
      </div>}
    </Modal>
  );
};
